import React from "react";

// Kit chip: toggles, filters, tabs and choices (28px, styles in src/styles/ui-kit.css .inyc-btn-chip).
// size="lg" (2.25rem): the main category filters in the home header.
// Icon only (no children) = round 2.25rem (.is-icon), e.g. the filters toggle next to a search field.
// `color` tints the selected state for category chips (category palette, always white text: user's call); otherwise selected is inverted.
const Chip = ({ selected = false, size = "md", icon = null, color, type = "button", className = "", style, children, ...rest }) => (
  <button
    type={type}
    aria-pressed={selected}
    className={`inyc-btn-chip ${selected ? "is-active" : ""} ${children == null ? "is-icon" : ""} ${size === "lg" ? "is-lg" : ""} ${className}`.replace(/\s+/g, " ").trim()}
    style={selected && color ? { backgroundColor: color, borderColor: color, color: "var(--inyc-on-fill)", ...style } : style}
    {...rest}
  >
    {icon}
    {children != null && <span>{children}</span>}
  </button>
);

export default Chip;
